export default {
      id: "tjk-not-found-usage",
      viewBox: "0 0 120 120",
      url: "/" + "images/icons.3.109.2.svg#tjk-not-found-usage",
      toString: function () {
        return this.url;
      }
    }